// Every fan-visible string on /account lives here, so a test can pin it and
// a reviewer can read the whole screen's copy in one file.

export const ACCOUNT_HEADING = "Account";
export const EDIT_PROFILE_ACTION = "Edit profile";
export const MEDALS_SECTION_TITLE = "Medals and trophies";
export const SCOPE_THIS_SEASON_LABEL = "This season";
export const SCOPE_ALL_TIME_LABEL = "All-time";
export const SCOPE_TABS_LABEL = "Award period";
export const AWARDS_UNAVAILABLE = "We could not load your medals just now.";
export const AWARD_SHEET_TITLE = "Award details";
export const AWARD_SHEET_POOL_LABEL = "Pool";
export const AWARD_SHEET_CONTEST_LABEL = "Contest";
export const AWARD_SHEET_UNKNOWN_VALUE = "Not recorded";
export const AWARD_SHEET_CLOSE_LABEL = "Close";
export const FAVORITE_TEAMS_TITLE = "Favorite teams";
export const FIND_TEAMS_ACTION = "Find teams";
export const TEAMS_EMPTY_TITLE = "No teams yet";
export const TEAMS_EMPTY_BODY = "Follow a team to get its scores and alerts.";
export const BROWSE_TEAMS_ACTION = "Browse teams";
export const YOUR_POOLS_TITLE = "Your pools";
export const SEE_ALL_ACTION = "See all";
export const POOLS_EMPTY = "No pools yet.";
export const GO_TO_POOLS_ACTION = "Go to pools";
export const POOLS_UNAVAILABLE = "We could not load your pools just now.";
export const PROFILE_UNAVAILABLE = "We could not load your profile just now.";
export const SETTINGS_GROUP_TITLE = "Settings";
export const SIGN_OUT_ACTION = "Sign out";
export const SIGN_OUT_HINT = "Signs you out on this device only.";
export const ACCOUNT_POOLS_PREVIEW_LIMIT = 3;

/** The accessible name of a settings row badge, e.g. "2 follow requests waiting". */
export function followRequestBadgeLabel(count: number): string {
  return count === 1
    ? "1 follow request waiting"
    : `${count} follow requests waiting`;
}

export type typeAccountSettingsRow = {
  /** Suffix of the row's test id: `account-settings-row-${key}`. */
  key:
    | "followers"
    | "follows"
    | "settings"
    | "notifications"
    | "sessions"
    | "privacy";
  label: string;
  to: string;
};

// Privacy has no screen of its own on web: PrivacyCard (toggles plus the Blocked list link) is the first card on /settings (ISSUE-1025).
// Followers (ISSUE-1372) leads: it is the one row that can be waiting on the
// fan, and it carries the count of follow requests waiting for them.
export const ACCOUNT_SETTINGS_ROWS: readonly typeAccountSettingsRow[] = [
  { key: "followers", label: "Followers", to: "/account/followers" },
  // ISSUE-1378 and ISSUE-1400, the same row the phone's account screen has.
  { key: "follows", label: "Sports you follow", to: "/account/follows" },
  { key: "settings", label: "Settings", to: "/settings" },
  {
    key: "notifications",
    label: "Notifications",
    to: "/account/settings/notifications",
  },
  {
    key: "sessions",
    label: "Sign-in methods and sessions",
    to: "/settings/sessions",
  },
  {
    key: "privacy",
    label: "Privacy and blocked list",
    to: "/settings",
  },
] as const;
